import type { MouseEvent } from 'react';
import { IconButton, Tooltip } from 'components/ui';
import { PushPin } from 'icons';
import type { SelectionPinButtonProps } from './SelectionPinButton.props';
import { selectionPinButtonClasses, SelectionPinButtonOutlinedIcon } from './SelectionPinButton.styles';

const SelectionPinButton = ({ id, isPinned, onToggle, title }: SelectionPinButtonProps) => (
  <Tooltip title={isPinned ? 'Unpin' : 'Pin'}>
    <IconButton
      aria-label="pin"
      onClick={(event: MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        onToggle?.(id, title, isPinned);
      }}
      size="small"
      sx={{ ml: 1 }}
    >
      {isPinned ? (
        <PushPin fontSize="small" htmlColor="rgba(0, 0, 0, 0.6)" />
      ) : (
        <SelectionPinButtonOutlinedIcon
          className={selectionPinButtonClasses.outlinedIcon}
          fontSize="small"
          htmlColor="rgba(0, 0, 0, 0.6)"
        />
      )}
    </IconButton>
  </Tooltip>
);

export default SelectionPinButton;
